import { DemandRoleSummary } from 'components/organisms/resource-management/common-types/demand';
import {
  DemandCapacityEvent,
  SchedulerEventType,
} from 'components/organisms/resource-management/event-types';
import { SchedulerResourceType } from 'components/organisms/resource-management/resource-types';
import { resourceIdForDemandResource } from '../../id';
import { getSchedulerEventProps } from '../common';
import { idForDemandEvent } from './common';

export const asDemandCapacityEvent = (
  roleSummary: DemandRoleSummary,
): DemandCapacityEvent => ({
  type: SchedulerEventType.DemandCapacity,
  resourceId: resourceIdForDemandResource(
    roleSummary.roleId,
    SchedulerResourceType.DemandCapacity,
  ),
  id: idForDemandEvent(
    SchedulerEventType.DemandCapacity,
    roleSummary.roleId,
    roleSummary.startDate,
    roleSummary.forViewPreset,
  ),
  startDate: roleSummary.startDate.toDate(),
  endDate: roleSummary.endDate.toDate(),
  roleId: roleSummary.roleId,
  capacity: roleSummary.capacity,
  forViewPreset: roleSummary.forViewPreset,
  ...getSchedulerEventProps(SchedulerEventType.DemandCapacity),
});
